import {EpetJs} from '@/utils/epetsdk'
/**
 * 配置文件
 */
var host_haiji = {
	local:'http://192.168.10.222:9206',
	dev:'http://alliance-api.dev.haijipet.com',
	product:'http://alliance-api.haijipet.com',
	version:"v1"
}
var host_haijipet_func = function(serveName='',version='v1') {
    if (version) {
        return process.env.NODE_ENV == 'development' 
            ? `${host_haiji['dev']}${serveName ? '/' + serveName : ''}${version ? '/' + version : ''}`
            : `${host_haiji[EpetJs.Const.ENV]}${serveName ? '/' + serveName : ''}${version ? '/' + version : ''}`
    } else {
        return process.env.NODE_ENV == 'development' 
            ? `${host_haiji['dev']}${serveName ? '/' + serveName : ''}` 
            : `${host_haiji[EpetJs.Const.ENV]}${serveName ? '/' + serveName : ''}`
    }
}
var host_base_url = process.env.NODE_ENV == 'development' ? '/api' : host_haiji[EpetJs.Const.ENV] + '/' + host_haiji.version;

/**
 * 配置文件
 */
// var cdn_host = {
// 	local:'http://192.168.10.222:9206',
// 	dev:'http://192.168.10.222:9206',
// 	product:'https://mallcdn.api.epet.com',
// 	version:"v3"
// }
// var host_cdn_url = process.env.NODE_ENV == 'development' ? '/api' : cdn_host[EpetJs.Const.ENV] + '/' + cdn_host.version;

export {
    host_base_url,
    host_haijipet_func
}
